<div class="content">
  <h1>Olá, como podemos ajudar?</h1>

  <div class="input-area">
    <div id="ask-input">
      <app-input placeholder="Faça uma pergunta"
      (input)="inputChange($event)"
      [iconPathAlt]="{
        'alt': 'Lupa',
        'path': 'search',
        'rightPosition': true
      }"
      [loading]="loading"></app-input>
    </div>
    <p>Encontre respostas para as perguntas frequentes</p>
  </div>

  <div id="categories">
    <app-faq-card title="Geral"
    icon="new_gear"
    (click)="filterFaq('general')"
    [selected]="category === 'general'">
    </app-faq-card>
    <app-faq-card title="Campanhas"
    icon="loudspeaker"
    (click)="filterFaq('campaigns')"
    [selected]="category === 'campaigns'"></app-faq-card>
    <app-faq-card title="Leads"
    icon="leads"
    (click)="filterFaq('leads')"
    [selected]="category === 'leads'"></app-faq-card>
  </div>

  <app-faq-list [list]="filteredFaq"></app-faq-list>

  <div id="still-doubts">
    <h2>Ainda tem dúvidas?</h2>
    <p>Então entre em contato com o nosso suporte por email ou por WhatsApp</p>
    <div id="cards">
      <app-faq-card title="lopesleads@lopes.com.br" 
      icon="email_red"
      titleColor="black"
      (click)="sendMail()"></app-faq-card>
      <app-faq-card title="(11) 94059-8940" 
      icon="whatsapp_logo"
      titleColor="black"
      (click)="sendMessage()"></app-faq-card>
    </div>
    
    <lib-button-primary class="btn"
    (click)="goBack()">
      Voltar
    </lib-button-primary>
  </div>
</div>